import { TFunction } from 'i18next';

const statusCodes = {
  closed: '0',
  answered: '1',
  open: '2',
  inDevelopment: '3',
};

export const userSuggestionStatuses = {
  closed: {
    code: statusCodes.closed,
    getLabel: (t: TFunction) => t('closed'),
    color: '#C4C4C4',

    canVote: false,
    canComment: false,
    adminCommentMustChangeStatus: false,
    isFinal: true,

    statusTargets: [],
  },

  answered: {
    code: statusCodes.answered,
    getLabel: (t: TFunction) => t('answered'),
    color: '#FC8A05',

    canVote: true,
    canComment: true,
    adminCommentMustChangeStatus: false,
    isFinal: false,

    statusTargets: [statusCodes.inDevelopment, statusCodes.closed],
  },

  open: {
    code: statusCodes.open,
    getLabel: (t: TFunction) => t('open'),
    color: '#1560CE',

    canVote: true,
    canComment: true,
    adminCommentMustChangeStatus: true,
    isFinal: false,

    statusTargets: [statusCodes.answered, statusCodes.inDevelopment, statusCodes.closed],
  },

  inDevelopment: {
    code: statusCodes.inDevelopment,
    getLabel: (t: TFunction) => t('in-development'),
    color: '#00D39D',

    canVote: true,
    canComment: true,
    adminCommentMustChangeStatus: false,
    isFinal: false,

    statusTargets: [statusCodes.answered, statusCodes.closed],
  },
};

export const suggestionByCode = Object.fromEntries(
  Object.values(userSuggestionStatuses).map((c) => [c.code, c]),
);
